import React from "react";

const GuildLineSteps = ({ imgs, steps }) => {
  const StepContent = ({ stepNumber, title, description }) => (
    <div className="row no-gutters">
      <div className="col-sm mb-3 mb-md-5 pb-md-5">
        <img
          src={imgs[stepNumber]}
          alt="Create a Zipmex account"
          className="img-fluid"
        />
      </div>

      <div className="col-sm-1 text-center flex-column d-none d-sm-flex">
        <h5 className="m-0">
          <span className="badge badge-pill border">&nbsp;</span>
        </h5>
        <div className="row h-100">
          <div className="col border-right">&nbsp;</div>
          <div className="col">&nbsp;</div>
        </div>
      </div>

      <div className="col-sm">
        <div>
          <h3 className="mb-4" dangerouslySetInnerHTML={{ __html: title }} />
          <div
            className="mb-5"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="guild-line__steps container">
      <div className="row no-gutters">
        <div className="col-sm"> </div>

        <div className="col-sm-1 text-center flex-column d-none d-sm-flex">
          <div className="row h-25">
            <div className="col border-right-faded">&nbsp;</div>
            <div className="col">&nbsp;</div>
          </div>
        </div>

        <div className="col-sm"></div>
      </div>

      {steps.map((step, i) => (
        <StepContent
          key={i}
          stepNumber={i}
          title={step.title}
          description={step.description}
        />
      ))}
    </div>
  );
};

export default GuildLineSteps;
